import React, {
  useRef,
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
  useContext,
} from 'react';
import {
  Checkbox,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Radio,
  Rate,
  Select,
  Switch,
  TimePicker,
  TreeSelect,
  Upload,
} from '@arco-design/web-react';
import { Col, Row, SelectForm } from '..';
import { useI18n } from '@/hooks/useLocale';
import { Slider } from 'bizcharts';
import { useMountedState } from '@/hooks/useMountedState';
import { GlobalContext } from '@/context';
const defaultRules = {};
const defaultInitData = {};
const shareValue = { stopTriggerChange: false };
function _LoongInCommonForm (
  {
    children,
    initData = defaultInitData, //初始化数据
    newFormData, //新数据，用于更新
    formItem, //表单项{label:string,fieldName:string,type:string,dataType:string, itemProps:object,}[]
    rules = defaultRules, //校验规则
    onChange, //表单数据改变事件
    onChangeBefore, //表单数据改变前触发事件
    disabled = false, //是否不可编辑
    render, //渲染
    event, //事件
    layout = 'horizontal', //horizontal | vertical | inline
    sizeClass = 'small', //'mini' | 'small' | 'default' | 'large'
    style, //
    className, //
    labelCol = { flex: '100px' },
    wrapperCol = { flex: '1' },
  },
  ref
) {
  const t = useI18n();
  const { lang } = useContext(GlobalContext);
  const FormItem = Form.Item;
  const formRef = useRef(null);
  const [innerData, setInnerData] = useState(initData);
  const [commonformItems, setCommonformItems] = useState(null);
  const isMounted = useMountedState();
  const [changeStatus, setChangeStatus] = useState(false);
  const getRule = (fieldName) => {
    if (!rules) return [];
    const rule = rules[fieldName];
    if (!rule) return [];
    const newRule = [];
    for (let index = 0; index < rule.length; index++) {
      const r = rule[index];
      if (rule[index]?.validator) {
        newRule.push({
          ...r,
        });
      } else {
        newRule.push({
          ...r,
          message: r.message
            ? r.message.indexOf('t_') >= 0
              ? t(r.message)
              : r.message
            : t('t_ruleError'),
        });
      }
    }
    return newRule;
  };
  const renderFormItemControl = (
    type,
    dataType,
    options,
    labelFieldName,
    valueFieldName,
    childrenFieldName,
    render,
    showClearIcon,
    multiselect,
    selectform,
    getValue,
    currDisabled,
    rest
  ) => {
    let isDisabled = disabled || currDisabled;    //判断当前的表单是否禁用（disabled：全局|currDisabled当前项禁用）
    if (type == 'text' && dataType == 'text') {
      rest.allowClear = showClearIcon;
      return <Input placeholder={!isDisabled ? t('t_pleaseInput') : ''} {...rest} />;
    } else if (
      type == 'textarea' ||
      (type == 'text' && dataType == 'textarea')
    ) {
      rest.allowClear = showClearIcon;
      return <Input.TextArea placeholder={!isDisabled ? t('t_pleaseInput') : ''} {...rest} />;
    } else if (
      type == 'password' ||
      (type == 'text' && dataType == 'password')
    ) {
      rest.allowClear = showClearIcon;
      return <Input.Password placeholder={!isDisabled ? t('t_pleaseInput') : ''} {...rest} />;
    } else if (type == 'dropdown') {
      rest.allowClear = showClearIcon;
      if (valueFieldName != 'value' || labelFieldName != 'label') {
        options &&
          options.forEach((item) => {
            item.value = item[valueFieldName];
            item.label = item[labelFieldName];
          });
      }
      if (multiselect !== undefined) rest.mode = 'multiple';
      return (
        <Select placeholder={!isDisabled ? t('t_pleaseSelect') : ''} options={options} {...rest} />
      );
    } else if (type == 'selectForm') {
      rest.allowClear = showClearIcon;
      if (valueFieldName != 'value' || labelFieldName != 'label') {
        options &&
          options.forEach((item) => {
            item.value = item[valueFieldName];
            item.label = item[labelFieldName];
          });
      }
      if (multiselect !== undefined) rest.mode = 'multiple';
      return (
        <SelectForm
          placeholder={!isDisabled ? t('t_pleaseSelect') : ''}
          options={options}
          selectform={selectform}
          getValue={getValue}
          labelFieldName={labelFieldName}
          valueFieldName={valueFieldName}
          {...rest}
        />
      );
    } else if (type == 'treeSelect') {
      rest.allowClear = showClearIcon;
      if (multiselect !== undefined) rest.multiple = multiselect;
      return (
        <TreeSelect
          placeholder={!isDisabled ? t('t_pleaseSelect') : ''}
          treeData={options}
          fieldNames={{
            key: valueFieldName,
            title: labelFieldName,
            children: childrenFieldName,
          }}
          {...rest}
        />
      );
    } else if (type == 'number' || (type == 'text' && dataType == 'number')) {
      rest.allowClear = showClearIcon;
      return <InputNumber placeholder={!isDisabled ? t('t_pleaseInput') : ''} {...rest} />;
    } else if (type == 'checkboxGroup') {
      return (
        <Checkbox.Group
          type={dataType}
          placeholder={!isDisabled ? t('t_pleaseSelect') : ''}
          {...rest}
        >
          {options &&
            options.map((itm, idx) => {
              return (
                <Checkbox
                  key={idx}
                  disabled={itm.disabled}
                  value={itm[valueFieldName]}
                >
                  {itm[labelFieldName]}
                </Checkbox>
              );
            })}
        </Checkbox.Group>
      );
    } else if (type == 'radio') {
      return (
        <Radio.Group
          type={dataType}
          placeholder={!isDisabled ? t('t_pleaseSelect') : ''}
          {...rest}
        >
          {options &&
            options.map((itm, idx) => {
              return (
                <Radio
                  key={idx}
                  disabled={itm.disabled || disabled}
                  value={itm[valueFieldName]}
                >
                  {itm[labelFieldName]}
                </Radio>
              );
            })}
        </Radio.Group>
      );
    } else if (type == 'checkbox') {
      return <Checkbox {...rest}></Checkbox>;
    } else if (type == 'switch') {
      return <Switch {...rest} />;
    } else if (type == 'rate') {
      return <Rate {...rest} />;
    } else if (type == 'slider') {
      return <Slider {...rest} />;
    } else if (type == 'year') {
      return <DatePicker.YearPicker placeholder={!isDisabled ? t('pickerYear.placeholder') : ' '} {...rest} />;
    } else if (type == 'month') {
      return <DatePicker.MonthPicker placeholder={!isDisabled ? t('pickerMonth.placeholder') : ' '} {...rest} />;
    } else if (type == 'week') {
      return <DatePicker.WeekPicker placeholder={!isDisabled ? t('pickerWeek.placeholder') : ' '} {...rest} />;
    } else if (type == 'quarter') {
      return <DatePicker.QuarterPicker placeholder={!isDisabled ? t('pickerQuarter.placeholder') : ' '} {...rest} />;
    } else if (type == 'date') {
      return <DatePicker placeholder={!isDisabled ? t('pickerDate.placeholder') : ' '} {...rest} name={rest.fieldName} />;
    } else if (type == 'time') {
      if (!rest.format) rest.format = 'HH:mm';
      return <TimePicker placeholder={!isDisabled ? t('pickerTime.placeholder') : ' '} {...rest} />;
    } else if (type == 'rangePicker') {
      return <DatePicker.RangePicker placeholder={!isDisabled ? [t('pickerRangeStart.placeholder'), t('pickerRangeEnd.placeholder')] : [' ', ' ']} {...rest} />;
    } else if (type == 'div') {
      return render && render();
    } else if (type == 'upload') {
      if (rest?.listType == 'picture-card') {
        // const aa = (a, b) => {
        //   console.log(a, b, "aa");
        // }
        return <div>
          <Upload showUploadList={false} multiple name="files" {...rest} disabled={disabled} />
        </div>;
      }
      return <Upload showUploadList={false} multiple name="files" {...rest} />
    }
  };
  // formItem, //表单项{label:string,fieldName:string,type:string,rules:RulesProps[] ,controlProps:object,}[]
  const renderCommonFormItem = (item, index) => {
    const {
      disabled, //是否可用
      label, //标签
      fieldName, //字段名
      type, //控件类型text | textarea | password | dropdown | treeSelect | number | radio | checkbox | checkboxGroup
      //      | switch | rate | slider | year | month | week | quarter | date | time | rangePicker | div | upload
      dataType, // type=radio 时 ，dataType作为radio的type，其他弃用。
      options, //dropdown、radio、treeSelect、checkboxGroup时的选项
      labelFieldName = 'label', //options标签对应的字段名
      valueFieldName = 'value', //options值对应的字段名
      childrenFieldName = 'children', //treeSelect时的子节点的名称
      render, //type == div时，用于渲染
      showClearIcon, //是否显示清除图标
      multiselect, //是否多选。
      formItemProps = {}, //Form.Item的其他属性
      selectform, //选择窗体
      getValue, //获取值
      style, //
      labelCol,
      wrapperCol,
      extra,
      ...rest //控件的其他属性
    } = item;
    if (disabled !== undefined) {
      formItemProps.disabled = disabled;
    }
    return (
      <div
        style={{ display: 'flex', marginRight: 24 }}
        className="del-arco-form-layout-inline-margin-right"
      >
        <FormItem
          key={index}
          style={style}
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          label={t(label) ?? label}
          field={fieldName}
          extra={extra}
          triggerPropName={
            type == 'checkbox' || type == 'switch' ? 'checked' : undefined
          }
          rules={getRule(fieldName)}
          {...formItemProps}
        >
          {renderFormItemControl(
            type,
            dataType,
            options,
            labelFieldName,
            valueFieldName,
            childrenFieldName,
            render,
            showClearIcon,
            multiselect,
            selectform,
            getValue,
            disabled,
            rest
          )}
        </FormItem>
        {item?.slot ? item.slot : null}
      </div>
    );
  };
  const renderFormItem = (item, index) => {
    if (!item) return '';
    if (item && item.type === 'row') {
      if (item.children) {
        let childrens = item.children.filter(elem => !elem?.hidden) //如何项中hidden为true则隐藏项
        return (
          <Row
            slot={item.slot}
            key={'r' + index}
            align={item.align} //flex 布局下的垂直对齐方式，可选值为 top、middle、bottom	String
            justify={item.justify} //布局下的水平排列方式，可选值为 start、end、center、space-around、space-between
            gutter={item.gutter || 10} //栅格间距，单位 px，左右平分 类型：Number 默认：0
            wrap={item.wrap} //是否自动换行	类型：Boolean	默认：true
            className={item.className} //自定义的class名称
          >
            {childrens.map((itm, idx) => {
              return (
                <Col
                  key={'c' + index + '_' + idx}
                  flex={itm?.flex} // flex 布局属性
                  span={itm?.span} // 栅格的占位格数，可选值为0~24的整数，为 0 时，相当于 display:none
                  order={itm?.order} // 栅格的顺序，在 flex 布局模式下有效
                  offset={itm?.offset} // 栅格左侧的间隔格数，间隔内不可以有栅格
                  push={itm?.push} // 栅格向右移动格数
                  pull={itm?.pull} // 栅格向左移动格数
                  className={itm?.className} // 自定义的class名称
                  xs={itm?.xs} //<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
                  sm={itm?.sm} // >=576px 响应式栅格，可为栅格数或一个包含其他属性的对象
                  md={itm?.md} // >=768px 响应式栅格，可为栅格数或一个包含其他属性的对象
                  lg={itm?.lg} // >=992px 响应式栅格，可为栅格数或一个包含其他属性的对象
                  xl={itm?.xl} // >=1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
                  xxl={itm?.xxl} // >=1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
                >
                  {renderFormItem(itm?.col, idx)}
                </Col>
              );
            })}
          </Row>
        );
      }
    } else if (item.type === 'jsx') {
      return <div key={'r' + index}>{item?.render()}</div>;
    } else {
      return renderCommonFormItem(item, index)
    }
  };
  const changeCommonformItems = () => {
    let formItemList = formItem.filter((item) => !item?.hidden)
    formItemList = formItemList.map((item, index) =>
      renderFormItem(item, index)
    );
    if (!render) {
      setCommonformItems(formItemList);
    } else {
      let form = {};
      formItemList.forEach((c) => {
        let slotname = c?.props?.slot;
        if (!form[slotname]) {
          form[slotname] = [];
        }
        form[slotname].push(c);
      });
      setCommonformItems(render(form));
    }
  };
  const validate = () => {
    return formRef?.current?.validate();
  };
  const resetForm = () => {
    setChangeStatus(false);
    return formRef?.current?.resetFields();
  };
  const getTouchedFields = () => {
    return formRef?.current?.getTouchedFields();
  };
  const getFieldsError = () => {
    return formRef?.current?.getFieldsError();
  };
  const setFieldsValue = (obj) => {
    return formRef?.current?.setFieldsValue(obj);
  };
  const setFieldValue = (filename, value) => {
    formRef?.current?.setFieldValue(filename, value);
  }
  const onValuesChange = (value, values) => {
    if (shareValue.stopTriggerChange) {
      shareValue.stopTriggerChange = false;
      return;
    }
    const oldData = innerData;
    let newInnerData = values;
    const fieldName = [];
    if (value) {
      for (const key in value) {
        fieldName.push(key);
      }
    }
    if (onChangeBefore) {
      newInnerData = { ...newInnerData };
      onChangeBefore(newInnerData, oldData, fieldName);
      shareValue.stopTriggerChange = true;
      setFieldsValue(newInnerData);
    }
    setInnerData(newInnerData);
    onChange && onChange(newInnerData, oldData, fieldName?.[0] || '');
  };
  const _onChange = (value, values) => {
    setChangeStatus(true);
  };
  const validField = (fieldName, value) => {
    formRef.current.validate(fieldName);
  };
  const getChangeStatus = () => {
    return changeStatus;
  };
  const getFormItem = () => {
    return formItem;
  };
  const setFormData = async (newFormData) => {
    if (newFormData) {
      shareValue.stopTriggerChange = true;
      if (newFormData?._fieldName) {
        setFieldValue(newFormData._fieldName, newFormData[newFormData._fieldName])
      } else {
        setFieldsValue(newFormData);
      }
    } else {
      const newData = initData || {};
      setFieldsValue(newData);
    }
  }
  useEffect(() => {
    if (!isMounted()) return;
    setFormData(newFormData)
  }, [newFormData]);
  useEffect(() => {
    if (!isMounted()) return;
    if (formItem) changeCommonformItems();
  }, [formItem, rules, lang]);
  useImperativeHandle(ref, () => ({
    validate,
    resetForm,
    getTouchedFields,
    getFieldsError,
    setFieldsValue,
    validField,
    getChangeStatus,
    getFormItem,
  }));
  return (
    <Form
      disabled={disabled}
      ref={formRef}
      autoComplete="off"
      size={sizeClass}
      initialValues={initData}
      onValuesChange={onValuesChange}
      onChange={_onChange}
      scrollToFirstError
      layout={layout}
      style={style}
      className={className}
      labelCol={layout != 'vertical' ? labelCol : { span: 7 }}
      wrapperCol={layout != 'vertical' ? wrapperCol : { span: 17 }}
    >
      {commonformItems}
      {children}
    </Form>
  );
}

export const LoongInCommonForm = forwardRef(_LoongInCommonForm);
